import React from "react";
import { Icon, Loader } from "semantic-ui-react";
import { EnergyPerformanceWorkspace, InstallationPicker, useInstalaciones } from "../../../components/Admin/EnergyPerformance";
import { useAuth } from "../../../hooks";
import { useLanguage, useSite } from "../../../contexts";
import { isAdmin, isMaster } from "../../../utils/checkPermission";
import "./EnergyPerformance.scss";

// Fase 1 (Diagnóstico y autoevaluación) del módulo de Desempeño Energético
// ISO 50001. A diferencia de EnvironmentalRiskMatrixForms (muchos registros
// por sitio), acá cada sitio tiene UNA instalación con muchas secciones
// editables progresivamente — la página solo resuelve sitio → instalación y
// delega la navegación entre módulos a EnergyPerformanceWorkspace. Además de la planta del sitio se pueden ver los
// 22 ejemplos (solo lectura) y las copias para practicar (InstallationPicker).
export function EnergyPerformance() {
  const {
    user: { role, site },
  } = useAuth();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  // El administrador y el master eligen el sitio en el encabezado; el resto queda en su sitio activo (el del token),
  // aunque en este navegador haya quedado guardado otro sitio.
  const siteContext = useSite().site;
  const eligeSitio = isAdmin(role) || isMaster(role);
  const siteSelected = (eligeSitio ? siteContext || site : site) || null;

  const instalaciones = useInstalaciones(siteSelected);
  // permisos por acción (hoja 23 p. 24-26 y 66): por ahora solo el administrador (y el master) modifica
  const puedeEditar = isAdmin(role) || isMaster(role);

  const showSiteWarning = siteSelected === null;

  return (
    <div className="energy-performance-page">
      <div className="energy-performance-page__wrap">
        <div className="energy-performance-page__header">
          <h1 className="energy-performance-page__title">{t("energy_performance_page_title")}</h1>
          <p className="energy-performance-page__subtitle">{t("energy_performance_page_subtitle")}</p>
        </div>

        {showSiteWarning ? (
          <div className="energy-performance-page__no-site">
            <Icon name="warning sign" size="big" />
            <p>{t("select_company_site_from_header")}</p>
          </div>
        ) : instalaciones.sinAcceso ? (
          <div className="energy-performance-page__no-site">
            <Icon name="lock" size="big" />
            <p>{t("energy_performance_site_no_access")}</p>
          </div>
        ) : instalaciones.real === undefined ? (
          <Loader active inline="centered" />
        ) : (
          <>
            <InstallationPicker estado={instalaciones} t={t} puedeEditar={puedeEditar} />
            <EnergyPerformanceWorkspace
              installation={instalaciones.installation}
              siteSelected={siteSelected}
              onInstallationSaved={instalaciones.onSaved}
              puedeEditar={puedeEditar}
            />
          </>
        )}
      </div>
    </div>
  );
}
